<template>
  <div class="location-container">
    <div v-if="location">
      <h4>Details for {{ location.title }}</h4>
      <b-form>
        <b-form-group>
          <label for="title">Title</label>
          <b-form-input id="title" v-model="location.title">{{
            location.title
          }}</b-form-input>
        </b-form-group>
        <b-form-group>
          <label for="street">Street</label>
          <b-form-input id="street" v-model="location.street">{{
            location.street
          }}</b-form-input>
        </b-form-group>
        <b-form-group>
          <label for="city">City</label>
          <b-form-input id="city" v-model="location.city">{{
            location.city
          }}</b-form-input>
        </b-form-group>
        <b-form-group>
          <label for="state">State</label>
          <b-form-input id="state" v-model="location.state">{{
            location.state
          }}</b-form-input>
        </b-form-group>
        <b-form-group>
          <label for="zip">Zip Code</label>
          <b-form-input id="zip" v-model="location.zip">{{
            location.zip
          }}</b-form-input>
        </b-form-group>
        <loading-panel :loading="loading" class="action-bar">
          <div class="button-bar">
            <button class="btn btn-primary w-25" @click.prevent="chooseOwner">
              Assign Facility Owner
            </button>
            <button class="btn btn-primary w-25" @click.prevent="save">
              Save
            </button>
          </div>
        </loading-panel>
      </b-form>
    </div>
    <div v-else>Please select a location.</div>
    <error-panel class="m-auto" :errors="errors"></error-panel>
    <div v-if="showOwnerPicker" class="popup-background">
      <div class="popup-content">
        <div class="label">Which facility company owns this location?</div>
        <div class="label">
          Selected: {{ selectedCompany ? selectedCompany.name : "none" }}
        </div>
        <div class="facility-company-list">
          <loading-panel
            :loading="true"
            message="Loading Facility Owner Companies"
            v-if="isLoadingFacilityOwners"
          />
          <button
            v-for="company in companies"
            :key="`company-${company.id}`"
            class="company-option"
            :class="
              selectedCompany && selectedCompany.id == company.id
                ? 'selected'
                : ''
            "
            @click="selectedCompany = company"
          >
            {{ company.name }}
          </button>
        </div>
        <loading-panel :loading="isSubmittingOwner" message="Submitting...">
          <div class="popup-action-bar">
            <button @click.prevent="showOwnerPicker = false" class="">
              Cancel
            </button>
            <button
              @click.prevent="() => submitOwner()"
              class="btn btn-primary"
            >
              Submit
            </button>
          </div>
        </loading-panel>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "location",
  props: {
    location: {},
  },
  data: () => ({
    loading: false,
    errors: [],
    filter: "",
    showOwnerPicker: false,
    isLoadingFacilityOwners: false,
    isSubmittingOwner: false,
    selectedCompany: null,
    companies: [],
  }),
  methods: {
    async save() {
      try {
        this.loading = true;
        const response = await this.$web.updateLocation(this.location);
      } catch (err) {
        console.log(err);
        this.errors = ["An error occurred."];
      } finally {
        this.loading = false;
      }
    },
    async loadFacilityOwners() {
      this.isLoadingFacilityOwners = true;
      try {
        const response = await this.$web.getCompanies();
        if (response.data.companies && response.data.companies.length > 0) {
          this.companies = response.data.companies.filter((c) => !c.isVendor);
        } else {
          this.errors = ["No companies found."];
        }
      } catch (err) {
        alert("Failed to load facility owner companies.");
      } finally {
        this.isLoadingFacilityOwners = false;
      }
    },
    async chooseOwner() {
      this.showOwnerPicker = true;
      this.loadFacilityOwners();
    },
    async submitOwner() {
      if (!this.selectedCompany) {
        alert("Please select the company that will own this location");
        return;
      }
      try {
        this.isSubmittingOwner = true;
        const response = await this.$web.setArchivedOwner(
          this.location.id,
          this.selectedCompany.id
        );
        alert("Successfully transferred ownership");
        this.showOwnerPicker = false;
        window.location.reload();
        // await this.loadFacilityOwners();
      } catch (err) {
        console.log("Caught error: ", err);
        alert(
          "Failed to set that company as the owner of the selected location."
        );
      } finally {
        this.isSubmittingOwner = false;
      }
    },
  },
  async mounted() {
    console.log(this.location);
  },
};
</script>

<style scoped>
.location-container {
  padding: 20px;
}

.button-bar {
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 8px;
  padding: 20px;
}

.popup-background {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);

  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-content {
  width: 500px;
  height: 500px;
  background: #fff;
  border-radius: 8px;
  padding: 20px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 12px;
}
.facility-company-list {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  background: #f0f0f0;
  border-radius: 8px;
}
.facility-company-list button {
  padding: 12px;
}
.facility-company-list .selected {
  background: #313d55;
  color: white;
}
.popup-action-bar {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
</style>
